import  {eXcell,__extends} from './eXcell';

var eXcell_co = (function (_super) {
    __extends(eXcell_co, _super);
    function eXcell_co(a) {
        _super.call(this);
        if (a) {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
            this.combo = this.cell._combo || this.grid.getCombo(this.cell._cellIndex);
            this.editable = true;
        }
    }
    eXcell_co.prototype.shiftNext = function () {
        var c = this.list.options[this.list.selectedIndex + 1];
        if (c) {
            c.selected = true;
        }
        this.obj.value = this.list.options[this.list.selectedIndex].text;
        return true;
    };
    eXcell_co.prototype.shiftPrev = function () {
        if (this.list.selectedIndex != 0) {
            var c = this.list.options[this.list.selectedIndex - 1];
            if (c) {
                c.selected = true;
            }
            this.obj.value = this.list.options[this.list.selectedIndex].text;
        }
        return true;
    };
    eXcell_co.prototype.edit = function () {
        this.val = this.getValue();
        this.text = this.getText()._dhx_trim();
        var g = this.grid.getPosition(this.cell);
        this.obj = document.createElement("TEXTAREA");
        this.obj.className = "dhx_combo_edit";
        this.obj.style.height =
            this.cell.offsetHeight - (this.grid.multiLine ? 9 : 4) + "px";
        this.obj.wrap = "soft";
        this.obj.style.textAlign = this.cell.style.textAlign;
        this.obj.onclick = function (o) {
            (o || event).cancelBubble = true;
        };
        this.obj.onmousedown = function (o) {
            (o || event).cancelBubble = true;
        };
        this.obj.value = this.text;
        this.obj.onselectstart = function (o) {
            if (!o) {
                o = event;
            }
            o.cancelBubble = true;
            return true;
        };
        var l = this;
        this.obj.onkeyup = function (s) {
            var r = (s || event).keyCode;
            if (r == 38 || r == 40 || r == 9) {
                return;
            }
            var u = this.readonly ? String.fromCharCode(r) : this.value;
            var v = l.list.options;
            for (var o = 0; o < v.length; o++) {
                if (v[o].text.indexOf(u) == 0) {
                    return (v[o].selected = true);
                }
            }
        };
        this.list = document.createElement("SELECT");
        this.list.className = "dhx_combo_select";
        this.list.style.width = this.cell.offsetWidth + "px";
        this.list.style.left = g[0] + "px";
        this.list.style.top = g[1] + this.cell.offsetHeight + "px";
        this.list.onclick = function (s) {
            var r = s || window.event;
            var o = r.target || r.srcElement;
            if (o.tagName == "OPTION") {
                o = o.parentNode;
            }
            l.editable = false;
            l.grid.editStop();
            r.cancelBubble = true;
        };
        var c = this.combo.getKeys();
        var h = false;
        var n = 0;
        for (var e = 0; e < c.length; e++) {
            var m = this.combo.get(c[e]);
            this.list.options[this.list.options.length] = new Option(m, c[e]);
            if (c[e] == this.val) {
                n = this.list.options.length - 1;
                h = true;
            }
        }
        if (h == false) {
            this.list.options[this.list.options.length] = new Option(this.text, this.val === null ? "" : this.val);
            n = this.list.options.length - 1;
        }
        document.body.appendChild(this.list);
        this.list.size = "6";
        this.cstate = 1;
        if (this.editable) {
            this.cell.innerHTML = "";
        }
        else {
            this.obj.style.width = "0px";
            this.obj.style.height = "0px";
        }
        this.cell.appendChild(this.obj);
        this.list.options[n].selected = true;
        if (this.editable) {
            this.obj.focus();
            this.obj.focus();
        }
        if (!this.editable) {
            this.obj.style.visibility = "hidden";
            this.obj.style.position = "absolute";
            this.list.focus();
            this.list.onkeydown = function (o) {
                o = o || window.event;
                l.grid.setActive(true);
                if (o.keyCode < 30) {
                    return l.grid.doKey({
                        target: l.cell,
                        keyCode: o.keyCode,
                        shiftKey: o.shiftKey,
                        ctrlKey: o.ctrlKey
                    });
                }
            };
        }
    };
    eXcell_co.prototype.getValue = function () {
        //校验不为空
        return !goingValidation.isNotEmpty(this.cell.combo_value)
            ? ""
            : this.cell.combo_value;
    };
    eXcell_co.prototype.detach = function () {
        if (this.val != this.getValue()) {
            this.cell.wasChanged = true;
        }
        if (this.list.parentNode != null) {
            if (this.editable) {
                var c = this.list.options[this.list.selectedIndex];
                if (c && c.text == this.obj.value) {
                    this.setValue(this.list.value);
                }
                else {
                    var e = this.cell._combo || this.grid.getCombo(this.cell._cellIndex);
                    var g = e.values._dhx_find(this.obj.value);
                    if (g != -1) {
                        this.setValue(e.keys[g]);
                    }
                    else {
                        this.setValue((this.cell.combo_value = this.obj.value));
                    }
                }
            }
            else {
                this.setValue(this.list.value);
            }
        }
        if (this.list.parentNode) {
            this.list.parentNode.removeChild(this.list);
        }
        if (this.obj.parentNode) {
            this.obj.parentNode.removeChild(this.obj);
        }
        return this.val != this.getValue();
    };
    eXcell_co.prototype.getText = function () {
        return this.cell.innerHTML;
    };
    eXcell_co.prototype.setValue = function (g) {
        if (typeof g == "object") {
            var e = dhx4.ajax.xpath("./option", g);
            if (e.length) {
                this.cell._combo = new dhtmlXGridComboObject();
            }
            for (var c = 0; c < e.length; c++) {
                this.cell._combo.put(e[c].getAttribute("value"), e[c].firstChild ? e[c].firstChild.data : "");
            }
            g = g.firstChild.data;
        }
        if ((g || "").toString()._dhx_trim() == "") {
            g = null;
        }
        this.cell.combo_value = g;
        if (g !== null) {
            var a = (this.cell._combo || this.grid.getCombo(this.cell._cellIndex)).get(g);
            this.setCValue(a === null ? g : a, g);
        }
        else {
            this.setCValue("&nbsp;", g);
        }
    };
    return eXcell_co;
})(eXcell);
window.eXcell_co = eXcell_co;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_co.js